var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3 text-center"},[_c('span',{staticClass:"text-muted small font-weight-bolder"},[_vm._v(_vm._s(_vm.$t('login.version'))+" "+_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }